import React from 'react'
import { graphql } from 'react-apollo'
import { ApolloQueryResult } from 'apollo-client'
import gql from 'graphql-tag'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'

import { Store, UserData } from '../../reducers'
import { loginComplete, logout } from '../../actions/user'
import { parseToken } from '../../util/parseToken'
import { ErrorIndicator, LoadingIndicator } from '../Shared/LoadIndicators'

type Response = {
  exchangeToken: {
    error: string
    ok: boolean
    token: string
  }
}

type PdInputProps = {
  login: (userData: UserData) => any // tslint:disable-line no-any
  logout: () => any // tslint:disable-line no-any
}

type PdAuthProps = {
  exchangeToken: (token: string) => Promise<ApolloQueryResult<Response>>
} & PdInputProps

type PdAuthState = {
  initialized: boolean
  error: string | null
}

/*
  Users can log in to DBS from Peikko Designer using a menu link. WHen clicked, Enterprixe's
  side creates an authentication token for us which this components exchanges to a real authentication
  token we can actually use.
 */
class PdAuth extends React.Component<PdAuthProps, PdAuthState> {
  constructor(props: PdAuthProps) {
    super(props)
    this.state = {
      initialized: false,
      error: null
    }
  }

  async componentDidMount() {
    // We don't do proper parsing here and just rely on the pdauthtoken being the only
    // thing in the query string.
    const args = window.location.search.split('=')

    if (args.length === 2 && args[0] === '?pdlogintoken') {
      this.props.logout()
      const res = await this.props.exchangeToken(args[1])

      if (res.data && res.data.exchangeToken) {
        if (res.data.exchangeToken.ok) {
          const data = parseToken(res.data.exchangeToken.token)
          if (data) {
            this.props.login(data)
            window.localStorage.setItem(
              'peikko-dbs-token',
              res.data.exchangeToken.token
            )
            this.setState({ initialized: true, error: null })
            window.location.replace('/')
          }
        }
      }
      this.setState({ initialized: true, error: 'Automatic login failed' })
    } else {
      this.setState({ initialized: true })
    }
  }

  render() {
    if (!this.state.initialized) {
      return <LoadingIndicator message="Logging in..." />
    }
    if (this.state.error) {
      return (
        <ErrorIndicator
          btnText="Login manually"
          onClick={() =>
            (window.location.href = process.env.PUBLIC_URL + '/login')
          }
          message="automatic login failed"
        />
      )
    }

    return React.Children.only(this.props.children)
  }
}

const EXCHANGE_TOKEN_QUERY = gql`
  mutation ExchangeToken($token: String!) {
    exchangeToken(pdauthtoken: $token) {
      ok
      token
      error
    }
  }
`

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  login: (userData: UserData) => dispatch(loginComplete(userData)),
  logout: () => dispatch(logout())
})

export default connect(
  null,
  mapDispatchToProps
)(
  graphql<Response, PdInputProps, PdAuthProps>(EXCHANGE_TOKEN_QUERY, {
    props: ({ mutate }) => ({
      exchangeToken: (token: string) =>
        mutate && mutate({ variables: { token } })
    })
  })(PdAuth)
)



// WEBPACK FOOTER //
// ./src/Components/PdAuth/index.tsx